module.exports = flarum.core.compat['forum/app'];